import React from 'react'
import styles from "./tnpsc-admissions.module.css";
import Link from 'next/link';

const About_TNPSC = () => {
 

    const thirdlist1 =[
        {list:"All the tests will be conducted for 250 marks."},
        {list:"Question Paper cum Answer booklet will be provided only in Printed format."},
        {list:"Question papers based on the dynamics of TNPSC."},
        {list:"Our test series is a real simulation of the TNPSC Group I Main exam."},
        {list:"Explanatory Materials for Unit Tests in Bilingual (Soft Copy)."},
        {list:"Printed answer-booklets of SIA’s 2022 cleared candidates (Issued for both offline & online students in book format)"},
        {list:"Recorded Orientation/Discussion Videos.(For further reference)"},
        {list:"8*7 Individual Mentoring by Expert Team (Only at SIA Branches)"},
        {list:"Z+ Series – Group I Mains Current Affairs Material (Zero Current Affairs for Mains)"},
        {list:"Z+ Series – Crash Course for Main Current Affairs (For both offline and online students)"},
        {list:"“Skill Up Junction” - Motivational Session (By SIA’s Cleared Candidates periodically)"},
        {list:"Mentoring Carnival for Online and SIA Branch Students"},
        {list:"We will conduct a Doubt Clearing Session."},
        {list:"Value Addition Lecture Series (Only for Test Batch Students – on most important topics)"}
      ]

      const thirdlist2 =[
        {list:"All the tests will be conducted for 300 marks"},
        {list:"Question Paper cum Answer booklet will be provided only in Printed format"},
        {list:"Question papers based on the dynamics of TNPSC."},
        {list:"Our test series is a real simulation of the TNPSC Group II/IIA Main exam."},
        {list:"Our test series covers the syllabus holistically."},
        {list:"Provides platform for State Level Analysis of performance and improve your competency."},
        {list:"Flexible for working candidates to take the test as per their availability."},
        {list:"Special Focus will be given for Unit II, III, IV and V."},
        {list:"Explanatory notes for all Tests (Except Mock Tests) will be provided in bilingual mode. Shankar IAS Academy is the only institute that provides such facility."}
        
      ]    
  return (
    <>

  <section id="testseries">
    <div className='container'>
      <div className='row pt-3'>
      <div className={`${styles.democlass}`}>
      <h2 className={`${styles.pagemaintitles}`}>Most Trusted Test Series & Mains Crash Course</h2> 
      {/* <div className="text-xl-end">
            <Link href="/tnpsc-demo-class-video" ><button className={`${styles.normalbutton2} mt-2 mt-md-0`} type="submit">TNPSC Demo Classes</button></Link>
      </div> */}
      </div>
        <div className='col-lg-6 col-12 p-3' style={{backgroundColor:"#D9DFE6"}}>
        <h3 className={`${styles.contenttitles}`}>Highlights of TNPSC Group I Main Test Series</h3>
        <ul className={`${styles.ulclass} ps-1 pt-3 mb-0`}>
          {thirdlist1.map((item,index)=>(
              <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                      <div className="d-inline">
                          <p className={`${styles.ullispan} d-inline`}>
                          {item.list}
                          </p>
                      </div>
                </li>
          ))}
      </ul>
 
        </div>
        <div className='col-lg-6 col-12 p-3'style={{backgroundColor:"#E4E8ED"}}>
        <h3 className={`${styles.contenttitles}`}>Highlights of TNPSC Group I Main Test Series</h3>
        <ul className={`${styles.ulclass} ps-1 pt-3 mb-0`}>
            {thirdlist2.map((item,index)=>(
                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                        <div className="d-inline">
                            <p className={`${styles.ullispan} d-inline`}>
                            {item.list}
                            </p>
                        </div>
                  </li>
            ))}
        </ul>

        {/* <h3 className={`${styles.contenttitles} pt-3`}>Group II/IIA Mains 2022 Test Series</h3>
       <Link href="/tnpsc-group-II-mains-test-series" ><button className={`${styles.normalbutton1} mt-2 mt-md-0`} type="submit">Click here to join</button></Link> */}

        </div>
      </div>
    </div>
  </section>
 
    </>
  )
}

export default About_TNPSC;